import { apiRequest } from './apiClient';
import { prepInput, type McsPrepInput, type McsPrep, type McsCohortSummary } from '../../types/mcsPrep';
export const mcsPrepAPI = {
  get: () => apiRequest<McsPrep>({ endpoint: '/mcs/prep', method: 'GET' }),
  save: (record: McsPrepInput) => apiRequest<McsPrep, McsPrepInput>({ endpoint: '/mcs/prep', method: 'PUT', data: prepInput(record) }),
  cohortSummary: (id: number) => apiRequest<McsCohortSummary>({ endpoint: `/mcs/cohorts/${id}/summary`, method: 'GET' }),
};
